<template>
    <flex-element :tag="renderTag" :element-type="elementType">
        <div v-show="previewMode" v-html="renderTextPreview" />
        <div
            v-show="!previewMode"
            ref="richTextContent"
            :contenteditable="isContentEditable"
            @input="setChangedData(true)"
            @blur="onInput"
        />
    </flex-element>
</template>

<script>
import { mapMutations } from 'vuex';

import baseAtom from '@/mixins/base-atom/base-atom-smart';
import listenOnRootMixin from '@/mixins/listen-on-root';
import { AHeadingRich } from '@/data/data-models';
import { SHOW_MODAL } from '@/store/types/mutation-types';

const PLACEHOLDER_TEXT = '[Text here]';

export default {
    name: 'a-heading-rich',
    mixins: [baseAtom, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Rich Heading',
        },

        richText: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },

        tagDefault: {
            type: String,
            default: 'h2',
        },

        templateId: {
            type: String,
            default: '{1EDDB5BF-88F6-4657-A332-A4983A978D83}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            richTextNew: '',
            tagNew: '',
        };
    },

    computed: {
        renderTextPreview() {
            return this.richTextNew.includes(PLACEHOLDER_TEXT) ? '' : this.richTextNew;
        },

        renderTag() {
            return this.tagNew || this.tagDefault;
        },

        updatedElement() {
            return new AHeadingRich({
                ...this.updatedBaseElement,
                richText: this.richTextNew,
                tag: this.renderTag,
            });
        },
    },

    created() {
        this.listenOnRoot('flex::rich-text::save', this.onModalSave);
    },

    mounted() {
        this.setHtml();
    },

    methods: {
        ...mapMutations({
            showModal: SHOW_MODAL,
        }),

        setFieldValues() {
            this.richTextNew = this.richText;
            this.tagNew = this.tag;
        },

        setHtml() {
            this.$refs.richTextContent.innerHTML = this.richTextNew
                || this.defaultTagWrap(this.$slots.default ? this.$slots.default[0].text.trim() : PLACEHOLDER_TEXT);
        },

        defaultTagWrap(text) {
            return `<${ this.tagDefault }>${ text }</${ this.tagDefault }>`;
        },

        onEditHtml() {
            const editorEl = this.$refs.richTextContent;

            this.showModal({
                componentTag: 'rich-text-modal',
                data: {
                    elementId: this.id,
                    html: editorEl.innerHTML,
                    rteType: 'heading',
                },
            });
        },

        onModalSave(id, html) {
            if (this.id !== id) return;

            this.$refs.richTextContent.innerHTML = html;
            this.richTextNew = html;
            this.setChangedData(true);
        },

        onInput() {
            const isEmpty = this.$refs.richTextContent.innerText.trim().includes(PLACEHOLDER_TEXT);
            this.richTextNew = isEmpty ? '' : this.$refs.richTextContent.innerHTML;
        },
    },
};
</script>
